// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.tabs[data-v-5ce7b267] {\r\n  padding-bottom: 30px;\r\n  padding-right: 1%;\r\n  padding-left: 1%;\r\n  max-width: 100%;\r\n  overflow-x:auto;\n}\n.warning[data-v-5ce7b267] {\r\n    color: red;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
